import { Box, useTheme } from "@mui/material";
import React, { useEffect, useState } from "react";
import { BCPAngleLeft, BCPAngleRight } from "../components/icons/bcp/BCPIcons";
import {
  getSessionStorage,
  setSessionStorage,
} from "../components/layout/cookies/CookieFunctions";
import {
  findGetParameter,
  removeParam,
} from "../components/utilities/UtilityFunctions";

export function isAppMode() {
  const hasAppPath = (url) => {
    try {
      const urlObject = new URL(url);
      const pathSegments = urlObject.pathname.split("/");

      return pathSegments.includes("app");
    } catch (err) {
      console.error(err);
      return false;
    }
  };

  if (
    findGetParameter("appMode") === "true" ||
    getSessionStorage("appMode") ||
    hasAppPath(window.location.href)
  ) {
    return true;
  } else if (document?.referrer) {
    hasAppPath(document.referrer);
  } else {
    return false;
  }
}

export function isModalEmbed() {
  if (findGetParameter("modalEmbed") === "true") {
    return true;
  } else {
    return false;
  }
}

export default function AppOverlay() {
  const exchangeTokenParam = findGetParameter("exchange_token");
  const codeParam = findGetParameter("code");

  const [visitedUrls, setVisitedUrls] = useState(
    getSessionStorage("bcpHistory")
      ? JSON.parse(getSessionStorage("bcpHistory"))
      : []
  );
  const [urlIndex, setUrlIndex] = useState(
    getSessionStorage("bcpIndex")
      ? JSON.parse(getSessionStorage("bcpIndex"))
      : 0
  );

  const theme = useTheme();

  useEffect(() => {
    // Remove exchange_token param
    const currentUrl = exchangeTokenParam
      ? removeParam("exchange_token", window.location.href)
      : codeParam
        ? removeParam("code", window.location.href)
        : window.location.href;
    let _visitedUrls = getSessionStorage("bcpHistory")
      ? JSON.parse(getSessionStorage("bcpHistory"))
      : [currentUrl];
    let _urlIndex = getSessionStorage("bcpIndex")
      ? JSON.parse(getSessionStorage("bcpIndex"))
      : _visitedUrls.length - 1;

    // If current URL is new in history
    if (
      currentUrl !== _visitedUrls[_urlIndex] &&
      currentUrl !== _visitedUrls[_urlIndex - 1] &&
      currentUrl !== _visitedUrls[_urlIndex + 1] &&
      _urlIndex !== visitedUrls.length
    ) {
      _urlIndex = _urlIndex + 1;
      _visitedUrls.push(currentUrl);
    }

    // If the user goes back and then clicks a new link, delete all history above the current index and then set the index to end of url array, effectively deleting the "old" history
    if (
      _urlIndex !== _visitedUrls.length - 1 &&
      currentUrl !== _visitedUrls[_urlIndex] &&
      currentUrl !== _visitedUrls[_urlIndex + 1] &&
      currentUrl !== _visitedUrls[_urlIndex - 1]
    ) {
      _visitedUrls.splice(_urlIndex, Infinity);
      _visitedUrls.push(currentUrl);
      _urlIndex = _visitedUrls.length - 1;
      setSessionStorage("bcpIndex", JSON.stringify(_urlIndex));
      setUrlIndex(_urlIndex);
    } else {
      if (_urlIndex === _visitedUrls.length - 1) {
        setSessionStorage("bcpIndex", JSON.stringify(_urlIndex));
        setUrlIndex(_urlIndex);
      }
    }

    setSessionStorage("bcpHistory", JSON.stringify(_visitedUrls));
    setVisitedUrls(_visitedUrls);

    //eslint-disable-next-line
  }, [window.location.href]);

  return (
    <>
      <Box sx={{ p: 3 }} />

      <Box
        sx={{
          p: 1,
          zIndex: 99999,
          borderRadius: "30%",
          backgroundColor: "rgb(0 0 0 / 3%)",
          position: "fixed",
          bottom: "20px",
          left: "10px",
          color:
            urlIndex === 0
              ? theme?.palette?.text?.disabled
              : theme?.palette?.text?.primary,
        }}
        onClick={() => {
          if (visitedUrls && urlIndex !== 0) {
            setSessionStorage("bcpIndex", JSON.stringify(urlIndex - 1));
            setUrlIndex(urlIndex - 1);
            window.location.assign(visitedUrls[urlIndex - 1]);
          }
        }}
      >
        <BCPAngleLeft sx={{ fontsize: "16px", width: "16px" }} />
      </Box>

      <Box
        sx={{
          p: 1,
          zIndex: 99999,
          borderRadius: "30%",
          backgroundColor: "rgb(0 0 0 / 3%)",
          position: "fixed",
          bottom: "20px",
          right: "10px",
          color:
            urlIndex === visitedUrls.length - 1
              ? theme?.palette?.text?.disabled
              : theme?.palette?.text?.primary,
        }}
        onClick={() => {
          if (visitedUrls && urlIndex !== visitedUrls.length - 1) {
            setSessionStorage("bcpIndex", JSON.stringify(urlIndex + 1));
            setUrlIndex(urlIndex + 1);
            window.location.assign(visitedUrls[urlIndex + 1]);
          }
        }}
      >
        <BCPAngleRight
          sx={{
            fontsize: "16px",
            width: "16px",
          }}
        />
      </Box>
    </>
  );
}
